export const production = true;

export const environment = {
  production,
  API_BASE_URL: 'https://api.careapp.com.au',
  APP_BASE_URL: 'https://app.careapp.com.au/#',
  API_VERSION: 'api/v1',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBWvmTl7YRL30d-qrmKMuEPSbXssz6RHU8',
  ROLLBAR_ACCESS_TOKEN: '76c70f6830b546878a9576567872d0aa',
  ROLLBAR_ENV_NAME: 'PRODUCTION',
  STATS_TABLE_LIMIT: 5
};
